const API_URL = process.env.REACT_APP_API_URL || "";

const API_ORIGIN = API_URL.replace(/\/api\/?$/, "");

const getImageCandidate = (value) => {
  if (!value) return "";

  if (typeof value === "string") return value.trim();

  if (Array.isArray(value)) {
    for (const item of value) {
      const candidate = getImageCandidate(item);
      if (candidate) return candidate;
    }
    return "";
  }

  if (typeof value === "object") {
    if (typeof value.url === "string" && value.url.trim()) return value.url.trim();
    if (typeof value.src === "string" && value.src.trim()) return value.src.trim();
    if (typeof value.path === "string" && value.path.trim()) return value.path.trim();
    if (typeof value.image === "string" && value.image.trim()) return value.image.trim();
    if (typeof value.secure_url === "string" && value.secure_url.trim()) return value.secure_url.trim();
  }

  return "";
};

export const getAbsoluteImageUrl = (url) => {
  const candidate = getImageCandidate(url);
  if (!candidate) return "";

  const normalizedUrl = String(candidate).trim();

  if (!normalizedUrl) return "";
  if (/^https?:\/\//i.test(normalizedUrl)) return normalizedUrl;
  if (normalizedUrl.startsWith("//")) return `https:${normalizedUrl}`;

  let path = normalizedUrl;

  if (!path.startsWith("/")) {
    path = path.startsWith("uploads/") ? `/${path}` : `/uploads/${path}`;
  }

  const fallbackOrigin = typeof window !== "undefined" && window.location?.origin ? window.location.origin : "";
  const baseOrigin = API_ORIGIN || fallbackOrigin;

  return baseOrigin ? `${baseOrigin}${path}` : path;
};

export const getImageUrl = getAbsoluteImageUrl;

